import StampsWidget from './Widget';
export type { IStampsProps } from '../../types/stamps.types';

export { StampsWidget };
